function generatePlaceholder(collection) {
  switch (collection) {
    case "categories":
      return "Search for service or space";
    case "locations":
      return "Search for a location";
    default:
      return "Invalid collection";
  }
}

function generateTitle(collection) {
  switch (collection) {
    case "categories":
      return "Choose a service or space";
    case "locations":
      return "Choose a location";
    default:
      return "Invalid collection";
  }
}

export { generatePlaceholder, generateTitle };
